// import React, { useEffect } from 'react';

// function redirectToAppStore() {
//     var userAgent = navigator.userAgent || navigator.vendor || window.opera;

//     if (/android/i.test(userAgent)) {
//         window.location.href = "https://play.google.com/store/apps/details?id=com.sumangaleechit";
//     } else if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel'
//         && navigator.maxTouchPoints > 1
//     )) {
//         window.location.href = "https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147";
//     }
// }

// redirectToAppStore();

// import { useEffect } from 'react';

// function QRCode() {
//   useEffect(() => {
//     var userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     if (/android/i.test(userAgent)) {
//       window.location.href = "https://play.google.com/store/apps/details?id=com.sumangaleechit";
//     } else if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 )) {
//       window.location.href = "https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147";
//     }
//   }, []);

//   return null;
// }

// export default QRCode;
// if (urlParams.searchParams.has('qr-code-scan')) {

// import { useEffect } from 'react';

// function QRCode() {
//   useEffect(() => {
//     // if (window.location.pathname === '/QRCode') {
//     const urlParams = new URLSearchParams(window.location.pathname);
//     if (urlParams.get(window.location.pathname) === 'true') {
//     // if (urlParams.get('https://amrsumangaleejewellers.com/QRCode?qr-code-scan') === 'true') {
//       const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//       if (/android/i.test(userAgent)) {
//         window.location.href = 'https://play.google.com/store/apps/details?id=com.sumangaleechit';
//       } else if (
//         /iPad|iPhone|iPod/.test(userAgent) ||
//         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
//       ) {
//         window.location.href = 'https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147';
//       }
//     }
//   // }
//   }, []);

//   return null;
// }

// export default QRCode;

// import { useEffect } from 'react';

// function QRCode() {
//   useEffect(() => {
//     if (window.location.pathname === '/QRCode') {
//       const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//       if (/android/i.test(userAgent)) {
//         window.location.href = 'https://play.google.com/store/apps/details?id=com.sumangaleechit';
//       } else if (
//         /iPad|iPhone|iPod/.test(userAgent) ||
//         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
//       ) {
//         window.location.href = 'https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147';
//       }
//     }
//   }, []); 

//   return null; 
// }

// export default QRCode;

import { useEffect } from 'react'

function QRCode() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isQrCodeScanned = urlParams.get('qr-code-scan') === 'true';
    if (isQrCodeScanned ?? false) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.sumangaleechit';
      } else if (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      ) {
        window.location.href = 'https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147';
      }
    }
    console.log('Hiiii1');
  }, []);
  console.log('Hiiii2');

  return null;
}

export default QRCode;

// import { useEffect } from 'react';

// function QRCode() {
//   useEffect(() => {
//     if (window.location.pathname === '/QRCode') {
//       const urlParams = new URLSearchParams(window.location.search);
//       const isQrCodeScanned = urlParams.get('qr-code-scan') === 'true';
//       if (isQrCodeScanned ?? false) {
//         const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//         if (/android/i.test(userAgent)) {
//           window.location.href = 'https://play.google.com/store/apps/details?id=com.sumangaleechit';
//         } else if (
//           /iPad|iPhone|iPod/.test(userAgent) ||
//           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
//         ) {
//           window.location.href = 'https://apps.apple.com/in/app/amr-sumangalee-jewellers/id6448749147';
//         }
//       }
//     }
//     console.log('Hiiii1');
//   }, []);

//   console.log('Hiiii2');

//   return null;
// }

// export default QRCode;